import { useContext } from "react";
import WishSingleLineText from "../../../components/WishFormComponents/WishSingleLineText";
import WishFileControl from "../../../components/WishFormComponents/WishFileControl";
import useEnrollment from "../../../services/useEnrollment";
import WishToaster from "../../../components/WishToaster";
import EnrollmentContext from "../../../contexts/EnrollUserContext";

export default function BankDetailsPage() {
  const { enrollmentDetails, setEnrollmentDetails, setIsPageDirty, fieldErrors = {}, setFieldErrors } = useContext(EnrollmentContext);
  const clearFieldError = (...keys) => {
    setFieldErrors?.((prev) => {
      if (!prev) return prev;
      const next = { ...prev };
      let changed = false;
      keys.forEach((key) => {
        if (next[key]) {
          delete next[key];
          changed = true;
        }
      });
      return changed ? next : prev;
    });
  };
  const { getBankBranchDetails } = useEnrollment(1);
  const normalizeIfsc = (value) => value.toUpperCase().replace(/\s/g, "");
  const isValidIfsc = (value) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(normalizeIfsc(value));

  return (
    <div
      onChange={() => {
        setIsPageDirty(true);
      }}
    >
      <WishSingleLineText
        label="Account Holder"
        id="bankAccountName"
        required
        error={fieldErrors.account_name}
        initialValue={enrollmentDetails?.bankDetails?.account_name}
        onChange={(newValue) => {
          clearFieldError("account_name");
          setEnrollmentDetails({
            ...enrollmentDetails,
            bankDetails: { ...enrollmentDetails.bankDetails, account_name: newValue.toUpperCase() },
          });
        }}
      />
      <WishSingleLineText
        label="Account Number"
        id="bankAccountNo"
        required
        error={fieldErrors.account_no}
        initialValue={enrollmentDetails?.bankDetails?.account_no}
        onChange={(newValue) => {
          clearFieldError("account_no", "confirm_account_no");
          setEnrollmentDetails({
            ...enrollmentDetails,
            bankDetails: { ...enrollmentDetails.bankDetails, account_no: newValue },
          });
        }}
      />
      <WishSingleLineText
        label="Confirm Account Number"
        id="bankConfirmAccountNo"
        required
        error={fieldErrors.confirm_account_no}
        initialValue={enrollmentDetails?.bankDetails?.confirm_account_no}
        onChange={(newValue) => {
          clearFieldError("confirm_account_no");
          setEnrollmentDetails({
            ...enrollmentDetails,
            bankDetails: { ...enrollmentDetails.bankDetails, confirm_account_no: newValue },
          });
        }}
      />
      <WishSingleLineText
        label="IFSC Code"
        id="bankIfsc"
        required
        error={fieldErrors.ifsc}
        initialValue={enrollmentDetails?.bankDetails?.ifsc}
        onChange={(newValue) => {
          clearFieldError("ifsc");
          const normalizedIfsc = normalizeIfsc(newValue);

          if (isValidIfsc(newValue)) {
            getBankBranchDetails(newValue, (data) => {
              setEnrollmentDetails({
                ...enrollmentDetails,
                bankDetails: {
                  ...enrollmentDetails.bankDetails,
                  bank_name: data.bank_name,
                  branch_name: data.branch_name,
                  bank_district: data.bank_district ?? "",
                  bank_state: data.branch_state ?? "",
                  ifsc: normalizedIfsc,
                },
              });
            });
          } else {
            setEnrollmentDetails({
              ...enrollmentDetails,
              bankDetails: {
                ...enrollmentDetails.bankDetails,
                bank_name: "",
                branch_name: "",
                bank_district: "",
                bank_state: "",
                ifsc: normalizedIfsc,
              },
            });
          }
        }}
        onBlurred={(value) => {
          if (normalizeIfsc(value) && !isValidIfsc(value)) {
            WishToaster({
              toastMessage: "Enter a valid IFSC code!",
              toastType: "error",
            });
          }
        }}
      />
      <WishSingleLineText label="Bank Name" readonly initialValue={enrollmentDetails?.bankDetails?.bank_name} />
      <WishSingleLineText label="Bank Branch" readonly initialValue={enrollmentDetails?.bankDetails?.branch_name} />
      <WishFileControl
        label="Bank (proof of address)"
        initialValue={enrollmentDetails?.bankDetails?.bank_proof_file?.name}
        onChange={(fileName, fileObject) => {
          setEnrollmentDetails({
            ...enrollmentDetails,
            bankDetails: { ...enrollmentDetails.bankDetails, bank_proof_file: fileObject },
          });
        }}
      />
    </div>
  );
}
